import { Link } from 'react-router-dom';
import { allGames } from '@/mocks/games';
import GameCard from '@/components/base/GameCard';

export default function PopularGamesSection() {
  const hotGames = allGames.filter(g => g.isHot).slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              热门游戏
            </h2>
            <p className="text-foreground-600 text-sm">最受玩家欢迎的精品游戏</p>
          </div>
          <Link
            to="/category/jingdian"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {hotGames.map((game) => (
            <GameCard
              key={game.id}
              id={game.id}
              name={game.name}
              category={game.category}
              image={game.image}
              rating={game.rating}
              players={game.players}
              isHot={game.isHot}
              isNew={game.isNew}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/jingdian"
            className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部游戏 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}